import React from 'react'
import SurveyDetailsMain from '../../widgets/surveyComponents/Inner/SurveyDetailsMain'

function SupplierSurveyDetails() {
  return (
    <><SurveyDetailsMain /></>
  )
}

export default SupplierSurveyDetails